import styles from './jsonInfo.module.css';
import {toPersianDigits} from "../Tools/tools";

function JsonInfo({json}) {
    const infoArray = JSON.parse(json);

    const getValue = (value) => {
        if (`${value.Key}`.startsWith('CaculateField_')) {
            const fields = JSON.parse(`${value.Value}`);
            if (fields.deposit_changed !== undefined && fields.frequently_changed !== undefined) {
                return toPersianDigits(`رهن: ${fields.deposit.toLocaleString('fa-IR')} --- اجاره: ${fields.frequently.toLocaleString('fa-IR')}  قابل تبدیل به   رهن: ${fields.deposit_changed.toLocaleString('fa-IR')}  --- اجاره:  ${fields.frequently_changed.toLocaleString('fa-IR')}`);
            }
            else {
                return toPersianDigits(`رهن: ${fields.deposit.toLocaleString('fa-IR')} --- اجاره: ${fields.frequently.toLocaleString('fa-IR')}`);
            }
        }

        return toPersianDigits(value.Value);
    }
    return (<div className={styles.scrollContainer}>
        {infoArray.map((item, index) => (
            <div>
                <div className={styles.titre}>
                    <p>{item.Name}</p>
                    <p>{getValue(item)}</p>
                </div>

                <hr className={styles.divider}/>
            </div>

        ))}
    </div>);
}

export default JsonInfo;